import React from 'react';
import PageToggleBanner from './PageToggleBanner';
import { locationOptions } from '../../constants/locations';

const heightOptions = [
  '4\'0"',
  '4\'1"',
  '4\'2"',
  '4\'3"',
  '4\'4"',
  '4\'5"',
  '4\'6"',
  '4\'7"',
  '4\'8"',
  '4\'9"',
  '4\'10"',
  '4\'11"',
  '5\'0"',
  '5\'1"',
  '5\'2"',
  '5\'3"',
  '5\'4"',
  '5\'5"',
  '5\'6"',
  '5\'7"',
  '5\'8"',
  '5\'9"',
  '5\'10"',
  '5\'11"',
  '6\'0"',
  '6\'1"',
  '6\'2"',
  '6\'3"',
  '6\'4"',
  '6\'5"',
  '6\'6"',
  '6\'7"',
  '6\'8"',
  '6\'9"',
  '6\'10"',
  '6\'11"',
  '7\'0"',
  '7\'1"',
  '7\'2"',
];

const ageOptions = Array.from({ length: 81 }, (_, i) => i + 5);

const hairColorOptions = [
  'Black',
  'Dark Brown',
  'Brown',
  'Light Brown',
  'Auburn',
  'Red',
  'Strawberry Blonde',
  'Blonde',
  'Platinum Blonde',
  'Gray',
  'Silver',
  'White',
  'Salt & Pepper',
  'Bald',
  'Other',
];

const eyeColorOptions = [
  'Brown',
  'Dark Brown',
  'Light Brown',
  'Hazel',
  'Amber',
  'Green',
  'Blue',
  'Gray',
  'Blue-Gray',
  'Green-Gray',
  'Heterochromia',
  'Other',
];

function AboutTab({
  performerProfile,
  setPerformerProfile,
  profileSettings,
  setProfileSettings,
  location,
  setLocation,
  hiddenSections,
  handleToggleSection,
  renderPhotoSlot,
  handleSaveAll,
  saving,
}) {
  return (
    <>
      {/* REVIEW: extracted to PageToggleBanner */}
      <PageToggleBanner
        label="About Page"
        enabled={!hiddenSections.includes('about')}
        onToggle={() => handleToggleSection('about')}
      />

      {renderPhotoSlot('about', 'About Photos', 'Photos for your about section.')}

      <div className={`settings-card${hiddenSections.includes('about_bio') ? ' section-off' : ''}`}>
        <div className="settings-card-header settings-card-header-toggle">
          <h2>Biography</h2>
          <div
            className={`pill-toggle pill-toggle-sm${hiddenSections.includes('about_bio') ? '' : ' on'}`}
            onClick={() => handleToggleSection('about_bio')}
          >
            <div className="pill-toggle-knob" />
          </div>
        </div>
        {!hiddenSections.includes('about_bio') && (
          <div className="form-group">
            <textarea
              value={performerProfile.bio || ''}
              onChange={(e) => setPerformerProfile({ ...performerProfile, bio: e.target.value })}
              rows={8}
              placeholder="Tell your professional story..."
            />
          </div>
        )}
      </div>

      <div
        className={`settings-card${hiddenSections.includes('about_physical') ? ' section-off' : ''}`}
      >
        <div className="settings-card-header settings-card-header-toggle">
          <h2>Physical Details</h2>
          <div
            className={`pill-toggle pill-toggle-sm${hiddenSections.includes('about_physical') ? '' : ' on'}`}
            onClick={() => handleToggleSection('about_physical')}
          >
            <div className="pill-toggle-knob" />
          </div>
        </div>
        {!hiddenSections.includes('about_physical') && (
          <>
            <div className="form-row">
              <div className="form-group">
                <label>Height</label>
                <select
                  value={performerProfile.height || ''}
                  onChange={(e) =>
                    setPerformerProfile({ ...performerProfile, height: e.target.value })
                  }
                >
                  <option value="">Select height...</option>
                  {heightOptions.map((h) => (
                    <option key={h} value={h}>
                      {h}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Age Range</label>
                <div className="age-range-selects">
                  <select
                    value={performerProfile.age_range?.split('-')[0] || ''}
                    onChange={(e) => {
                      const endAge = performerProfile.age_range?.split('-')[1] || '';
                      const newRange = endAge ? `${e.target.value}-${endAge}` : e.target.value;
                      setPerformerProfile({ ...performerProfile, age_range: newRange });
                    }}
                  >
                    <option value="">From...</option>
                    {ageOptions.map((age) => (
                      <option key={age} value={age}>
                        {age}
                      </option>
                    ))}
                  </select>
                  <span className="age-range-separator">to</span>
                  <select
                    value={performerProfile.age_range?.split('-')[1] || ''}
                    onChange={(e) => {
                      const startAge = performerProfile.age_range?.split('-')[0] || '';
                      const newRange = startAge
                        ? `${startAge}-${e.target.value}`
                        : `-${e.target.value}`;
                      setPerformerProfile({ ...performerProfile, age_range: newRange });
                    }}
                  >
                    <option value="">To...</option>
                    {ageOptions.map((age) => (
                      <option key={age} value={age}>
                        {age}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Hair Color</label>
                <select
                  value={performerProfile.hair_color || ''}
                  onChange={(e) =>
                    setPerformerProfile({ ...performerProfile, hair_color: e.target.value })
                  }
                >
                  <option value="">Select hair color...</option>
                  {hairColorOptions.map((hc) => (
                    <option key={hc} value={hc}>
                      {hc}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Eye Color</label>
                <select
                  value={performerProfile.eye_color || ''}
                  onChange={(e) =>
                    setPerformerProfile({ ...performerProfile, eye_color: e.target.value })
                  }
                >
                  <option value="">Select eye color...</option>
                  {eyeColorOptions.map((ec) => (
                    <option key={ec} value={ec}>
                      {ec}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </>
        )}
      </div>

      <div
        className={`settings-card${hiddenSections.includes('about_location') ? ' section-off' : ''}`}
      >
        <div className="settings-card-header settings-card-header-toggle">
          <h2>Location & Representation</h2>
          <div
            className={`pill-toggle pill-toggle-sm${hiddenSections.includes('about_location') ? '' : ' on'}`}
            onClick={() => handleToggleSection('about_location')}
          >
            <div className="pill-toggle-knob" />
          </div>
        </div>
        {!hiddenSections.includes('about_location') && (
          <>
            <div className="form-row">
              <div className="form-group">
                <label>Location</label>
                <select value={location} onChange={(e) => setLocation(e.target.value)}>
                  <option value="">Select your location...</option>
                  {locationOptions.map((group) => (
                    <optgroup key={group.group} label={group.group}>
                      {group.options.map((loc) => (
                        <option key={loc} value={loc}>
                          {loc}
                        </option>
                      ))}
                    </optgroup>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Union Status</label>
                <input
                  type="text"
                  value={performerProfile.union_status || ''}
                  onChange={(e) =>
                    setPerformerProfile({ ...performerProfile, union_status: e.target.value })
                  }
                  placeholder="AEA, SAG-AFTRA, Non-Union..."
                />
              </div>
              <div className="form-group">
                <label>Representation</label>
                <input
                  type="text"
                  value={performerProfile.representation || ''}
                  onChange={(e) =>
                    setPerformerProfile({ ...performerProfile, representation: e.target.value })
                  }
                  placeholder="Agent/Manager info"
                />
              </div>
            </div>
          </>
        )}
      </div>

      <button className="btn-save-section" onClick={handleSaveAll} disabled={saving}>
        {saving ? 'Saving...' : 'Save About'}
      </button>
    </>
  );
}

export default AboutTab;
